import { useMemo } from 'react';

const useHoursMinutesListGenerator = (input: number, interval = 1) => {
  const list = useMemo(() => {
    const timeList: Array<{ text: string; value: string }> = [];
    const maxHours = input; // Maximum hours value
    const maxMinutes = (input * interval - 1) % 60; // Maximum minutes value

    for (let h = 0; h < maxHours; h++) {
      for (let m = 0; m < 60; m += interval) {
        if (h === maxHours && m > maxMinutes) break; // Break loop if it exceeds the maximum time

        const formattedHours = String(h).padStart(2, '0');
        const formattedMinutes = String(m).padStart(2, '0');
        timeList.push({ text: `${formattedHours}:${formattedMinutes}`, value: `${formattedHours}:${formattedMinutes}` });
      }
    }
    return timeList;
  }, [input, interval]);

  return list;
};

export default useHoursMinutesListGenerator;
